import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import {whiteEx} from '../../../assets/symbols/symbols/Symbols.css';
import StatusIcon from './icon/icon';
import {BRIGHT_RED} from '../../../globalVariables/GlobalVariables';
import {TICK_DOMAIN} from '../../../config/config';
import {useTranslation} from 'react-i18next';
import Card from './card/card';
import {OrderData} from '../suspendedConfirmation';

const ChargeFailed = ({orderData}: {orderData: OrderData}) => {
    const {t} = useTranslation('suspendedConfirmation');

    return (
        <Card subTitle={orderData.eventTitle} mainTitle={''} {...orderData} >
            <css.confirmationBox>
                <StatusIcon icon={whiteEx} color={BRIGHT_RED} />
                <css.errorTitle>
                    {t('failedTitle')}
                </css.errorTitle>
                <css.boldTextCenter>
                    {t('chargeFailedDescription')}
                </css.boldTextCenter>
            </css.confirmationBox>
                
            <css.buttonRow>
                <Btn onClick={()=>window.location.reload()}>{t('finish')}</Btn>
                <Btn href={TICK_DOMAIN} className="white" onClick={undefined}>{t('cancel')}</Btn>
            </css.buttonRow>
        </Card>
    );
};

export default ChargeFailed;